import { CONVERSION_MODE, STORE_LINKS } from "../constants/config";
import { trackEvent } from "../services/analytics";

export function areStoreLinksAvailable() {
  return (
    CONVERSION_MODE === "stores" &&
    Boolean(STORE_LINKS.ios || STORE_LINKS.android)
  );
}

function StoreBadge({ platform, label, href }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() =>
        trackEvent("cta_click", { location: "store_badge", variant: platform })
      }
      className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition bg-black text-white hover:bg-gray-900"
    >
      {label}
    </a>
  );
}

export default function StoreBadges({ className = "" }) {
  if (!areStoreLinksAvailable()) {
    return null;
  }

  return (
    <div
      id="store-badges"
      className={`flex flex-wrap items-center justify-center gap-3 ${className}`}
    >
      {STORE_LINKS.ios && (
        <StoreBadge
          platform="ios"
          label="Télécharger sur l'App Store"
          href={STORE_LINKS.ios}
        />
      )}
      {STORE_LINKS.android && (
        <StoreBadge
          platform="android"
          label="Disponible sur Google Play"
          href={STORE_LINKS.android}
        />
      )}
    </div>
  );
}
